import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DenyStudentEnrollmentMutation = graphql.persisted(
  "DenyStudentEnrollment",
  graphql(`
    mutation DenyStudentEnrollment($studentEnrollmentId: ID!) {
      denyStudentEnrollment(input: {studentEnrollmentId: $studentEnrollmentId}) {
        studentEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { DenyStudentEnrollmentMutation };

export function useDenyStudentEnrollment() {
  return useMutation(DenyStudentEnrollmentMutation);
}
